import {Pipe, PipeTransform} from '@angular/core';
import {fromUnixTime, isBefore} from 'date-fns';
import {OrderDto} from '../../../Models/Purchases/Orders/order.interface';
import {OrderStatusEnum} from '../../../Shared/Enum/order-status.enum';

@Pipe({
  name: 'orders',
  standalone: false
})
export class OrdersPipe implements PipeTransform {

  transform(items: OrderDto[], filter: FilterOrderPipe): OrderDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    const date = new Date();

    if (filter.provider) {
      items = items.filter((item) => item.id_proveedor == filter.provider);
    }

    if (filter.state) {
      items = items.filter((item) => {

        if (filter.state === OrderStatusEnum.finished) {
          return item.id_estado === OrderStatusEnum.sent && !item.enviado;
        }

        if (filter.state === OrderStatusEnum.sent) {
          return item.id_estado === OrderStatusEnum.sent && item.enviado;
        }

        return item.id_estado === filter.state;
      });
    }


    if (filter.local) {
      items = items.filter((item) => item.id_local == filter.local);
    }

    if (filter.menu === 'pendents') {
      items = items.filter((item) => isBefore(fromUnixTime(Number.parseFloat(item.fecha_recepcion) / 1000), date));
    }

    if (filter.menu === 'suggested') {
      items = items.filter((item) => item.sugerido);
    }

    if (filter.menu === 'favorites') {
      items = items.filter((item) => item.favorito);
    }

    return items;

  }

}

export interface FilterOrderPipe {
  provider?: number;
  state?: number;
  local?: number;
  menu?: string;
}
